import React, { useEffect, useState, useRef } from 'react';
import { FilterSearch } from '../SwiftIcon/Icons';
import '../../../css/CustomComponents/MACSearch.css';
import { titleCase } from '../../../exports/UtilFunctions';
import { COLOR_VARS } from '../../../exports/ColorVars';

function MACSearch({ title = 'Search Client', placeholder = 'Enter Customer Name', customers = [], onSelect = null, showSearch = true, hideOnSelect = false, selectedCustomer=null }) {

    const [filter, setFilter] = useState([]);
    const [search, setSearch] = useState('');
    const [focused,setFocused] =  useState(false);
    const [selected, setSelected] = useState(false);

    const MACRef = useRef();

    useEffect(()=>{
        if(selectedCustomer && selectedCustomer.name){
            setSearch(selectedCustomer.name);
        }
    },[selectedCustomer]);

    useEffect(() => {

        if (selected) {
            setFilter([]);
            return;
        };

        if(focused && search === ''){
            setFilter(customers);
            return;
        }

        if(search === ''){
            setFilter([]);
            return;
        }
        
        const data = customers.filter((c) => {
            return c.name.toLowerCase().includes(search.toLowerCase());
        });

        if(selectedCustomer && !focused){
            return;
        }

        setFilter(data);


    }, [focused,selected, search,customers]);

    useEffect(() => {
        const listener = (event) => {
            if (!MACRef.current || MACRef.current.contains(event.target)) {
                return;
            }

            if (!selected) { 
                // setSearch('');
                setFocused(false);
                setFilter([])
            }

            if(selectedCustomer && selectedCustomer.name){
                setSearch(selectedCustomer.name);
            }

        };
        document.addEventListener("mousedown", listener);
        document.addEventListener("touchstart", listener);
        return () => {
            document.removeEventListener("mousedown", listener);
            document.removeEventListener("touchstart", listener);
        };
    }, [selected, MACRef]);

    useEffect(() => {
        if (!showSearch) {
            setSearch('');
            setFocused(false);
        }
    }, [showSearch]);

    function handleSelect(val) {
        if (hideOnSelect) {
            setSearch('');
            setFocused(false);
        }
        else {
            setSearch(val.name);
            setFocused(false);
        }
        onSelect(val);
        setSelected(true);
    }

    return (
        <div className='customer-search-wrapper' ref={MACRef}>
            <p className='search-title'>{title}</p>
            <div className='customer-search-box'>
                <input placeholder={placeholder} value={titleCase(search)} onChange={(e) => setSearch(e.target.value)} onFocus={() => { setSearch('');setSelected(false); setFocused(true); }} />
                <div className='filter-icon'><FilterSearch size={20} color={COLOR_VARS["SWIFT_COLOR4"]} /></div>

                {filter?.length > 0 &&
                    <>
                        <div className='customer-search-result'>
                            {filter.map((f, index) => {
                                return <div onClick={() => handleSelect(f)} key={index} className='result-row'>
                                    <span>{f.scheme_name || f.customer_type}</span>
                                    <p>{f.name}</p>
                                </div>
                            })}
                        </div>

                    </>
                }

            </div>
        </div>
    )
}

export default MACSearch;